export default __webpack_public_path__ + "static/media/ps1.e0815751.png";